// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl:"https://investedapi.samsuat.com/api/",
  auth:{
        clientID: 'L8PP1RlhbaemtQiSSypr4AcMpl4TKVze',
        domain: 'invested.us.auth0.com',
        callbackURL: 'https://invested.samsuat.com',
        apiUrl: 'https://investedapi.samsuat.com' 
  },
  roleClaim:"https://investedenterprise.com/roles",
  institutioncolleges:"https://investedenterprise.com/claims/institutioncolleges",
  assignedsports:"https://investedenterprise.com/claims/assignedsports",
  tenantId:"4C204FBA-63EF-44DF-86E0-72B2B9E39F17",
  ncaaURL:'https://web3.ncaa.org/hsportal/exec/hsAction?hsCode={0}&state=&city=&name=&hsActionSubmit=Search',
};
